export default function isIE() {
    if (window && !!window.ActiveXObject || 'ActiveXObject' in window) {
        return true;
    }
    return false;
}
